import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SuperAdminSidebar from './SuperAdminSidebar';
import { requireSuperAdmin } from '@/middleware/superAdminGuard';
import ErrorBoundary from '@/components/system/ErrorBoundary';

interface Props {
  children: React.ReactNode;
}

export default function SuperAdminLayout({ children }: Props) {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAccess = async () => {
      const isSA = await requireSuperAdmin();
      if (!isSA) {
        navigate('/login', { replace: true });
      }
    };
    checkAccess();
  }, [navigate]);

  return (
    <div className="flex min-h-screen bg-[#f3f7fb]">
      <SuperAdminSidebar />
      <main className="flex-1 overflow-auto min-w-0">
        <ErrorBoundary fallbackRoute="/sa/dashboard" fallbackLabel="Back to SA dashboard">
          {children}
        </ErrorBoundary>
      </main>
    </div>
  );
}
